import { render, staticRenderFns } from "./TeacherStudentDetailsNameCell.vue?vue&type=template&id=198ddd3c&"
import script from "./TeacherStudentDetailsNameCell.vue?vue&type=script&lang=js&"
export * from "./TeacherStudentDetailsNameCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports